import { ProjectLists } from './project-lists';
import { SidebarCollapsibleSection } from 'components/blocks/layout/sidebar-section';
import { useState } from 'react';
import { NewProjectModal } from './new-project-modal';
import { useQueryClient } from '@tanstack/react-query';
import { refetchProject } from '../helpers/query-utils';
import { useTranslation } from 'react-i18next';
// import { useChatStore } from 'state/store/chat/use-chat-store';

export const ProjectsSection = ({ variant = 'figma' }: { variant?: 'default' | 'figma' }) => {
    const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    // const removeConversationFromSidebarById = useChatStore((state) => state.removeConversationFromSidebarById);

    return (
        <div className="mb-0">
            <SidebarCollapsibleSection
                title={t("PROJECTS_TITLE", "Projects")}
                onAddClick={() => setIsAddProjectModalOpen(true)}
                variant={variant}
            >
                <div className="flex flex-col gap-1">
                    <ProjectLists variant={variant} />
                </div>
            </SidebarCollapsibleSection>

            <NewProjectModal
                callback={() => {
                    refetchProject(queryClient, '');
                }}
                isOpen={isAddProjectModalOpen}
                onClose={() => setIsAddProjectModalOpen(false)}
            />
        </div>
    );
}